import iconv from 'iconv-lite';
import { Buffer } from 'buffer';

// UTF8 BOM - 0xEF, 0xBB, 0xBF
// UTF16 BOM - 0xFE, 0xFF
// UTF16le BOM = 0xFF, 0xFE

export function readTextFromBuffer(buffer: Buffer): string {
  if (!(buffer instanceof Buffer)) throw new Error('Input is not a buffer');
  if (!buffer.length) return '';

  const result = readWithBOM(buffer) || readWithoutBOM(buffer);
  if (result === null) {
    throw new Error('Error reading the file');
  }

  return result;
}

function hasBOM(buffer: Buffer, check: number[]) {
  if (buffer.length < check.length) return false;
  return check.every((v, i) => v == buffer[i]);
}

function readWithBOM(buffer: Buffer) {
  // Check for BOM
  if (hasBOM(buffer, [0xef, 0xbb, 0xbf])) {
    // utf8
    return buffer.toString('utf8');
  }

  if (hasBOM(buffer, [0xfe, 0xff])) {
    // utf16 be
    return iconv.decode(buffer, 'utf16-be');
  }

  if (hasBOM(buffer, [0xff, 0xfe])) {
    // utf16 le
    return iconv.decode(buffer, 'utf16-le');
  }
}

function readWithoutBOM(buffer: Buffer) {
  let result;
  try {
    result = buffer.toString('utf8');
    // TODO: remove final 2-3 characters in case of partial buffer, to not throw detection off.
  } catch (err) {
    result = null;
  }

  // has unknown "unicode" character - try win1252 encoding
  if (!result || result.includes(String.fromCharCode(65533))) {
    // TODO: check the buffer for "unknown" directly before win1252 conversion
    const result2 = iconv.decode(buffer, 'win1252');

    // only replace if loaded as win1252 does *not* have unicode "unknown" character,
    if (!result2.includes('\xEF\xBF\xBD')) {
      return result2 || null;
    }
  }
  return result || null;
}
